module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("I Hope You Dance: A Year of Weddings Novella")]), _c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ser1",
    attrs: {
      "id": "pAm8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#bb_2",
      "id": "aa_2"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images/img-7-1.jpg",
      "id": "z7-1",
      "src": "images/img-7-1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "pz7-4"
    }
  }, [_c('span', {
    staticClass: "tx1a"
  }, [_c('i', [_vm._v("Summers were made for weddings. Skye Foster had believed")])]), _vm._v(" that for the past twenty years—ever since she was six and a guest at a distant cousin’s wedding. This July she would have a small part to play in the wedding of Charity Anderson and Buck Malone. A wedding Skye knew would be the most beautiful and romantic ever held in Kings Meadow.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz7-5"
    }
  }, [_vm._v("When she closed her eyes, she could imagine it perfectly. The couple, standing in the gazebo with pastor, bridesmaids, and groomsmen, repeating their vows in the golden glow of an Idaho summer morning. The bride in white satin and lace, and the groom in a coat and tails. White folding chairs set up in the park, filled with friends and family. Women dabbing their eyes with tissues. The cutting of the many-layered cake. The music. The dancing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz7-6"
    }
  }, [_c('i', [_vm._v("Ah, yes")]), _vm._v(". As far as she was concerned, no wedding was complete without dancing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz8-5"
    }
  }, [_vm._v("She imagined the band playing a romantic country waltz. She imagined herself stepping into the arms of a tall, lanky cowboy, feeling the warmth of his hand as it closed around hers. She imagined moving around the dance floor, the fluttering of her heart in time with their steps.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz8-6"
    }
  }, [_vm._v("It was all so romantic.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz8-7"
    }
  }, [_vm._v("Taking a deep breath, she tilted her head back and mentally tried to see the face of the cowboy who turned her around the floor with such expertise. But here, at last, her imagination failed her. In her daydream, there was nothing but shadows beneath the brim of his Stetson.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz8-8"
    }
  }, [_vm._v("She released a sigh and opened her eyes again. It was hard to envision a romance when she didn’t even have a boyfriend. At the rate she was going, she would never get to plan a wedding of her own. But that didn’t stop her from wishing for it. Only now was not the time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz8-9"
    }
  }, [_vm._v("With another sigh, she set aside the latest issue of "), _c('i', [_vm._v("Brides")]), _vm._v(" magazine that had come in the mail, grabbed the keys to her truck, and left the house.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz8-10"
    }
  }, [_vm._v("First stop on her agenda was the Clippity Do-Da Hair Salon. It was time for a trim. Her mother, Midge—the owner of the salon—would plead with Skye, as usual, to let her try something different. And Skye would, as usual, refuse her. Long and straight was her style. She liked it and wasn’t about to change it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz8-11"
    }
  }, [_vm._v("Next up she had an appointment to meet the vet at the pasture where she kept her two horses, Snickers and Milky Way. Snickers had started limping a few days ago and didn’t seem to be improving, even with rest and the use of liniment. Skye hoped it wasn’t serious. The gelding was the best "), _c('span', {
    attrs: {
      "id": "z9-5"
    }
  }, [_vm._v("barrel-racing horse she’d ever owned—there’d been five over the years. He’d made her the queen of more than one rodeo by the time she turned twenty. Snickers had more heart than stamina these days, but that didn’t matter to Skye. She loved him to pieces. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz9-6"
    }
  }, [_vm._v("It took only minutes to drive to the east edge of town. On a Wednesday afternoon Skye was able to park on the street right in front of the salon. As she got out of the pickup, high-pitched voices called her name. She looked toward the corner and saw two teenage girls, books in their arms, apparently headed for the library. She knew them, of course, just as she knew almost everyone else in Kings Meadow. Krista and Sharon Malone, daughters of the high school principal.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz9-7"
    }
  }, [_vm._v("“Hey!” she called back with a wave of her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz9-8"
    }
  }, [_vm._v("The girls moved on out of sight, and Skye pushed open the door to the salon, a tiny bell ringing above her head. The main room—smelling of perm solution and fruity shampoo—was completely empty. No stylists. No customers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz9-9"
    }
  }, [_vm._v("Her mom looked out from the stockroom. “Skye! Is it that time already? Gracious. I thought I would have my inventory done before you got here.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz9-10"
    }
  }, [_vm._v("“Where is everybody?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz9-11"
    }
  }, [_vm._v("“Slow day. Lori doesn’t work most Wednesdays, and Becca finished with her last client an hour ago, so she went home. When I’m done with you, I’m doing the same thing.” She took a cape from a drawer and snapped it in the air, draping it around Skye as soon as she was in the chair. “What are we doing today?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz9-12"
    }
  }, [_vm._v("“Just trim the ends and shape my bangs.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz10-5"
    }
  }, [_vm._v("“How much off?” Her mom lifted a segment of hair.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz10-6"
    }
  }, [_vm._v("Skye swallowed a smile, knowing what was about to come. “An inch. No more.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz10-7"
    }
  }, [_vm._v("“Are you sure?” Her mom placed her fingers, like a pair of scissors, up a good six inches from the ends. “Because I think if we—”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz10-8"
    }
  }, [_vm._v("“I don’t want short hair, Mom, and you "), _c('i', [_vm._v("aren’t")]), _vm._v(" going to change my mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz10-9"
    }
  }, [_vm._v("Her mom met her gaze in the mirror. “Don’t you get tired of it always looking the same? You’ve had the same look since you were twelve, when you wouldn’t let me braid it anymore.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz10-10"
    }
  }, [_vm._v("“I haven’t always had bangs.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz10-11"
    }
  }, [_vm._v("Her mom groaned in frustration. “I give up.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz10-12"
    }
  }, [_vm._v("Skye laughed. “I wish I believed that.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz10-13"
    }
  }, [_vm._v("“Can I at least wash it for you?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz10-14"
    }
  }, [_vm._v("“I’m kinda in a hurry. I’ve got to meet Dr. Parry at the pasture. He’s taking a look at Snickers’s leg, and then I have to get home to shower and change and have a bite to eat before it’s time for my adult class. I’m teaching them the two-step tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz10-15"
    }
  }, [_vm._v("“How many couples have you got coming?” Her mom picked up the scissors and began trimming away the split ends.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz10-16"
    }
  }, [_vm._v("“Four couples. They’ve been a great group. I’m having a lot of fun with them.” She drew in a deep breath. “And next week I begin giving private lessons to the Anderson-Malone wedding-party members.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz10-17"
    }
  }, [_vm._v("“Already?” Her mom’s eyes widened as she met Skye’s gaze in the mirror again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz11-5"
    }
  }, [_vm._v("“It’s less than two months until the wedding. That’s hardly any time at all.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz11-6"
    }
  }, [_vm._v("“Seems like yesterday when you wondered if Buck Malone might be interested in you.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz11-7"
    }
  }, [_vm._v("Skye almost shook her head, but remembered in time to stay still. “That was last summer. Almost a year. Besides, he’d already fallen hard for Charity, so I was way wrong.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz11-8"
    }
  }, [_vm._v("“You never minded, did you?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz11-9"
    }
  }, [_vm._v("“Not even a little. And when you see Charity and Buck together, you know they were meant for each other.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz11-10"
    }
  }, [_vm._v("Her mom gave her a smile of encouragement. “You’ll meet somebody too. You’re still young, honey. You’ve got lots of time.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz11-11"
    }
  }, [_vm._v("Skye didn’t say so, but she’d begun to feel her biological clock ticking. If she only wanted one or two kids, it wouldn’t matter so much, but she had her heart set on a half dozen babies. Minimum. She’d always wanted to be part of a big family. Since her parents had chosen not to give her lots of siblings—only an older brother and sister—she intended to create that large family for herself. With the help of that still-elusive husband.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz11-12"
    }
  }, [_vm._v("“Close your eyes,” her mom said. As soon as Skye obeyed, her mom took the scissors to her bangs, leaving them long but giving them shape. "), _c('i', [_vm._v("Snip. Snip. Snip.")]), _vm._v(" “All right. You’re done. Hardly worth the time of coming into the salon, far as I can tell.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz11-13"
    }
  }, [_vm._v("Skye laughed. “You wouldn’t want me cutting my own hair, would you?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz11-14"
    }
  }, [_vm._v("“Heaven forbid! Remember what you did when you were five?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz12-5"
    }
  }, [_vm._v("“Yeah, but like you said, I was "), _c('i', [_vm._v("five")]), _vm._v(".” As soon as the cape was off, Skye stood and gave her mother a kiss on the cheek. “Love you, Mom.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz12-6"
    }
  }, [_vm._v("“I love you, too, baby girl. I hope Snickers is all right.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz12-7"
    }
  }, [_vm._v("“Thanks. I’ll let you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz12-8"
    }
  }, [_vm._v("She stepped outside a few moments later, intent on getting over to the pasture before the vet. So intent was she that she almost mowed down an unexpected passerby on the sidewalk.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz12-9"
    }
  }, [_vm._v("“Whoa, there,” a deep voice said. Strong hands gripped her upper arms and steadied her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz12-10"
    }
  }, [_vm._v("Skye looked up into the face of a stranger. He was rugged looking with a bit of mischief in his blue-green eyes and one of those I-haven’t-shaved-for-a-few-days beards that she liked on cowboys. He wasn’t movie-star handsome, but there was something about his looks that made her heart behave erratically.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz12-11"
    }
  }, [_c('i', [_vm._v("Who is this guy?")])]), _vm._v(" "), _c('p', {
    staticClass: "ser",
    attrs: {
      "id": "pz12-12"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images/img-12-1.jpg",
      "id": "z12-12",
      "src": "images/img-12-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "pz12-13"
    }
  }, [_vm._v("“Sorry, miss.” Grant Nichols released his hold on the young woman’s arms and took a step back. “Hope I didn’t hurt you.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz12-15"
    }
  }, [_vm._v("She shook her head, and her straight black hair waved across her narrow shoulders.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz12-17"
    }
  }, [_vm._v("“Maybe you can help me. Is there a dance studio around here?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz12-18"
    }
  }, [_vm._v("Her eyes widened. Big, brown, doe-like eyes. “Yes.” She pointed. “Around that corner and to the right.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz12-19"
    }
  }, [_vm._v("“Thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-5"
    }
  }, [_vm._v("“But it’s closed now.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-6"
    }
  }, [_vm._v("He almost said a curse word but managed to swallow it. The BC Grant—the Before Christ version—had cursed all the time. Breaking himself of that habit had been tough. It was just one of the reasons he’d kept to himself most of the time since arriving in Kings Meadow. God had delivered him of other bad habits, but the impulse to swear had hung on for dear life for the past four years.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-7"
    }
  }, [_vm._v("“Maybe I can help you,” she added, watching him closely. “I’m the owner of the studio.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-8"
    }
  }, [_vm._v("Every other thought fled. “You’re Skye Foster? Just the gal I’m supposed to see. I’m Grant Nichols. One of Buck Malone’s groomsmen. He told me to talk to you about those lessons you’re giving the wedding party.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-9"
    }
  }, [_vm._v("“Oh. Of course. I recognize your name, but we’ve never actually met. Have we?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-10"
    }
  }, [_vm._v("“No, we haven’t.” "), _c('i', [_vm._v("And I’m sure sorry about that.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-11"
    }
  }, [_vm._v("“Well, it’s nice to meet you now. As for the lessons, they’ll start next week. We’ll meet every Tuesday night until the wedding.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-12"
    }
  }, [_vm._v("“That’s my first problem. I work on Tuesday nights. Buck thought you and I might be able to work out a different schedule for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-13"
    }
  }, [_vm._v("“I suppose I could do that.” She tipped her head slightly to one side. “But if that’s your first problem, what’s your second?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-15"
    }
  }, [_vm._v("“Miss Foster, I’ve got two left feet.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-16"
    }
  }, [_vm._v("She laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-17"
    }
  }, [_vm._v("Man, what a smile. Perhaps he’d been too successful at keeping himself separate from the general population if her smile was what he’d been missing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-3"
    }
  }, [_vm._v("“I’m sure that’s not true, Mr. Nichols. Anybody can learn to dance.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-4"
    }
  }, [_vm._v("“Oh, it’s true. Ask every girl who’s ever had the misfortune to coax me onto a dance floor. They’re probably still sporting bruises and broken toes, years later.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-5"
    }
  }, [_vm._v("She shook her head again. Then she reached into the back pocket of her jeans and fished out a business card. “Listen, I have an appointment that I can’t be late for. Call me at this number. If I’m not in, leave a message and I’ll call you back. And don’t worry. We’ll find a time that will work, and I’ll have you dancing like a pro by the wedding. I love a challenge.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-6"
    }
  }, [_vm._v("He took the card and read it. "), _c('i', [_vm._v("Skye Foster, Two-Step Dance Studio")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-7"
    }
  }, [_vm._v("“Please excuse me, Mr. Nichols—”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-8"
    }
  }, [_vm._v("“Call me Grant.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-9"
    }
  }, [_vm._v("“Okay, Grant. But I’ve gotta run. I’ll talk to you soon.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-10"
    }
  }, [_vm._v("She stepped around him and hurried to the silver Toyota Tacoma parked at the curb. She hopped into the cab with no problem, despite looking too petite to drive such a rig. The engine started, and Skye drove away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-11"
    }
  }, [_vm._v("Grant stood there for a few moments, feeling winded by the encounter. Then he grinned. He’d dreaded taking the lessons, and only his friendship with Buck had made him agree to it. But suddenly it didn’t seem like a terrible idea after all. The weeks until the wedding might turn out to be a whole lot of fun.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba8ec1e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter02.vue
// module id = 72
// module chunks = 0